export const UPDATE_CRITERIA_TAB = ' UPDATE_CRITERIA_TAB';
export const UPDATE_IMPORT_TAB = 'UPDATE_IMPORT_TAB';
export const UPDATE_FILE = 'UPDATE_FILE';
export const RESET = 'RESET';
